import React, { useEffect, useState } from 'react';
import Layout from '../util/layout';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    const [name, setName] = useState("");
    const [mail, setMail] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState("");
    const [error, setError] = useState({field: '', message: ''});
    const [loading, isLoading] = useState(false);
    const [recaptcha, setRecaptcha] = useState(false);

    const onChange = (value) => {
        if (value !== null){
            setRecaptcha(true);
            setError({field: '', message: ''});
        }
        else
            setError({field: '', message: 'reCaptcha validation failed'});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess("");
        setError({field: '', message: ''});

        if(!name)
            setError({field: 'name', message: 'Please enter your name.'})
        else if(mail != "" && !pattern.test(mail))
            setError({field: 'mail', message: 'Please enter valid e-mail.'})
        else if(!message)
            setError({field: 'message', message: 'Please enter a message.'})
        else if(!recaptcha)
            setError({field: '', message: 'reCaptcha validation failed'})
        else{
            isLoading(true);
            const config = {
                headers: {
                    'content-type' : 'application/json'
                }
            };
            const url = 'https://2w3tn83u78.execute-api.eu-west-2.amazonaws.com/v1/send-email';
            const formData = new FormData();
            formData.append('from', 'support@signtechforms.com');
            formData.append('to', '');
            formData.append('type', 'contact_mail');
            formData.append('name', name);
            formData.append('email', mail);
            formData.append('phone', '');
            formData.append('message', message);
            formData.append('emailSubject', 'Contact US - ADO');
            try{
                const res = await axios.post(url, formData, config);
                if(res.data && res.data.success){
                    setSuccess('Email was sent successfully');
                    setName("");
                    setMail("");
                    setMessage("");
                }
                else
                    setError({
                        field: '',
                        message: 'Email was not sent successfully'
                    });
            }catch(err){
                console.log(err.message);
                setError({
                    field: '',
                    message: 'Email was not sent successfully'
                });
            }
            isLoading(false);
        }
    }

    useEffect(() => {
        setError({field: '', message: ''});
    },  [mail, message, name]);

    useEffect(() => {
        const interval = setInterval(() => {
            setSuccess("");
        }, 2000);
        return () => clearInterval(interval);
    }, [success]);

	return(
        <Layout title="Contact">
            <div className="page-header--image" data-overlay="">
                <div className="imagebg contact-background"></div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="sectiontitle-element--light--center">
                                <h1>Get in touch</h1>
                                <p>Please fill out this form to be contacted by a Sales Representative</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <section data-padding="xs">
                    <div className="container">
                        <div data-aos="fade-up" className="row align-items-lg-center aos-init aos-animate">
                            <div className="col-12 col-lg-8 offset-lg-2">
                                <form id="contact-form" onSubmit={handleSubmit}>
                                    <div className="basic-form--border--round--row">
                                        <div className="field col-lg-6">
                                            <label htmlFor="name">Your Name <sup>*</sup></label>
                                            <input 
                                                id="name"
                                                name="name"
                                                type="text" 
                                                className="form-field"
                                                value={name} 
                                                data-error={error && error.field == 'name' ? true : false}
                                                onChange={({target: {value}}) => setName(value)}
                                            />
                                        </div>
                                        <div className="field col-lg-6">
                                            <label htmlFor="mail">Email Address <sup>*</sup></label>
                                            <input 
                                                id="mail"
                                                name="mail" 
                                                type="email"
                                                value={mail}
                                                className="form-field"
                                                data-error={error && error.field == 'mail' ? true : false}
                                                onChange={({target: {value}}) => setMail(value)}
                                            />
                                        </div>
                                        <div className="field col-12">
                                            <label htmlFor="message">Message <sup>*</sup></label>
                                            <textarea 
                                                id="message"
                                                name="message"
                                                className="form-field"
                                                value={message}
                                                data-error={error && error.field == 'message' ? true : false}
                                                onChange={({target: {value}}) => setMessage(value)}
                                            />
                                        </div>
                                        <div className="field col-12" data-margin="xxsbottom">
                                            <ReCAPTCHA
                                                sitekey="6Lfh6X4lAAAAADhBaracexX_QcMgE6VAIQ6PXxuG"
                                                onChange={onChange}
                                            />
                                        </div>
                                        {
                                            error && error.message ?
                                                <div className="alert-wrap col-12" data-active="true">
                                                    <p>{error.message}</p>
                                                </div>
                                            : null
                                        }
                                        {
                                            success ?
                                                <div className="alert-wrap col-12 success" data-active="true">
                                                    <p>{success}</p>
                                                </div>
                                            : null
                                        }
                                        <div className="field col-12 text-center">
                                            <button className="btn--big--round" disabled={loading}>{loading ? 'Sending...' : 'Send Message'}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
}

export default Contact;